import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectCustomer } from '../../../../customer/state/detail/selector'

export default createUIDefinition({
    taskName: taskName.CHECK_ID,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
    ],
    overwriteWidget: true,
    taskValidatorSelector: [
        selectCustomer,
    ],
    taskValidator: (task, processInstance, taskName, eventName, customer) => {
        if (eventName !== 'id_checked') {
            return null
        }

        const messageList = []

        if (!customer.dob) {
            messageList.push(createValidationMessage('Please enter date of birth.', 'validateDateOfBirth.physicianId'))
        }

        if (!customer.firstName) {
            messageList.push(createValidationMessage('Please enter first name.', 'validateDateOfBirth.firstName'))
        }

        if (!customer.lastName) {
            messageList.push(createValidationMessage('Please enter last name.', 'validateDateOfBirth.lastName'))
        }

        if (!customer.streetAddress) {
            messageList.push(createValidationMessage('Please enter streetAddress.', 'validateDateOfBirth.streetAddress'))
        }

        if (!customer.zip) {
            messageList.push(createValidationMessage('Please enter zip code.', 'validateDateOfBirth.zip'))
        }

        if (!customer.city) {
            messageList.push(createValidationMessage('Please enter city.', 'validateDateOfBirth.city'))
        }

        if (!customer.countryCode) {
            messageList.push(createValidationMessage('Please enter Country.', 'validateDateOfBirth.Country'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/check-in/check-id.js